'use client';

import { Button, FormField } from '@shared/components/shadcn';
import { CloseAccount } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';
import { useMultistepForm } from '../../../../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import { Select } from '../../../../../../../form-controls/Select/Select';
import type { CloseAccountFormData } from '../../../types/close-account';

type SelectOption = {
  value: string;
  text: string;
};

const ReasonStep = () => {
  const { goToNextStep } = useMultistepForm();
  const { trigger, clearErrors } = useFormContext<CloseAccountFormData>();
  const t = useTranslations('my_account');
  const REASONS_PATH = 'pages.close_my_account.reason_step.reasons';

  const reasons = (t.has(REASONS_PATH) ? t.raw(REASONS_PATH) : {}) as Record<string, string>;
  const options: SelectOption[] = Object.entries(reasons).map(([value, text]) => ({
    value,
    text,
  }));

  const handleContinue = async () => {
    const isValid = await trigger(['reason']);
    if (isValid) {
      goToNextStep();
    }
  };

  return (
    <div className="w-full flex flex-col flex-1 gap-8" data-testid="reason-step">
      <CloseAccount size="extra-extra-large" data-testid="close-account-icon" />
      <div className="text-left">
        <h4>{t('pages.close_my_account.reason_step.title')}</h4>
        <p className="mt-2 text-muted-foreground">{t('pages.close_my_account.reason_step.message')}</p>
      </div>
      <div className="space-y-4">
        <FormField
          name="reason"
          render={({ field }) => (
            <Select
              {...field}
              onBlur={undefined}
              onChange={value => {
                field.onChange(value);
                clearErrors('reason');
              }}
              label={t('pages.close_my_account.reason_step.choose')}
              id="choose-reason"
              options={options}
              placeholder={t('pages.close_my_account.reason_step.reason')}
              data-testid="reason-select"
              data-track-name="Reason"
              data-track-helper="Reason"
            />
          )}
        />
      </div>
      <div className="mt-auto" data-track-container="Actions">
        <Button className="w-full" onClick={handleContinue} data-testid="continue-button" data-track-name="Continue">
          {t('actions_required.continue')}
        </Button>
      </div>
    </div>
  );
};

export { ReasonStep };
